import React from 'react';

import {CheckoutItemType} from 'desktop/types/checkoutItemsType';

import {PriceItem} from '../priceItem/priceItem';

import s from './cartItemDetailsRow.scss';

export type PropsType = {
    title: string;
    item: CheckoutItemType;
};

/**
 * Cart lenses Item Details Row for checkout page
 *
 * @constructor
 */
export const CartItemLensesDetailsRow: React.FC<PropsType> = ({item, title}) => {
    return (
        <div className={s.row}>
            {title === 'Lens Type' && (
                <>
                    {item.product.contactLensType}, {item.product.contactLensPerBox} Pack
                </>
            )}
            {title === 'Package' && (
                <>
                    <strong>Price per box: </strong>
                    <PriceItem finalPrice={item.discountedPrice} price={item.product.price} />
                </>
            )}
        </div>
    );
};
